import React from 'react';

export function KeyboardArrowUpIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M14.82 30.82L24 21.66l9.18 9.16L36 28 24 16 12 28l2.82 2.82z" />
    </svg>
  );
}
